import service from "@/api/service";
import { GetResponse } from "@/api/point-user/response";
import { GetRequest } from "@/api/point-user/request";

/**
 * ポイントカードお客様情報取得APIをコールします。
 *
 * @return GetResponse
 */
export async function get(getRequest: GetRequest) {
  const response = await service.post("/get-point-user", getRequest);
  return response.data as GetResponse;
}
